// extracted by mini-css-extract-plugin
export default {"wrapper":"NothingHere_wrapper__QdGCl","number":"NothingHere_number__ppb9L","text":"NothingHere_text__rfSXE"};